import TabSwitcherWeb from "@components/switcher/TabSwitcherWeb";
import AddInstitution from "./AddInstitution";
import CurrentInstitutions from "./CurrentInstitutions";

const InstituionalManagement = () => {
  const tabs = [
    { label: "CURRENT INSTITUTIONS", component: <CurrentInstitutions /> },
    {
      label: "ADD A INSTITUTION",
      component: <AddInstitution />,
    },
  ];
  return (
    <>
      <div className="h-[70px] border-b border-border-subtle bg-bg-page-body flex flex-row sticky top-0 bg-white z-10 pl-[20px] w-full">
        <p className="flex text-text-base text-[14px] font-semibold items-center">
          Institution Management
        </p>
      </div>
      <div className="flex justify-start mx-4 mt-[20px]">
        <TabSwitcherWeb tabs={tabs} full={true} />
      </div>
    </>
  );
};

export default InstituionalManagement;
